import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VListItem,{attrs:{"link":"","disabled":!_vm.detail.enabled,"to":_vm.detail.to}},[_c(VListItemContent,[_c(VListItemTitle,{staticClass:"pl-2"},[_vm._v(_vm._s(_vm.detail.title))])],1)],1),_vm._l((_vm.pinned_abook_worklists),function(detail){return _c(VListItem,{key:detail.title,attrs:{"link":"","disabled":!detail.enabled,"to":detail.to}},[_c(VListItemContent,[_c(VListItemTitle,{staticClass:"pl-2"},[_vm._v("- "+_vm._s(detail.title))])],1)],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }